import {
	DIRECTORY_GET_STATUS,
	DIRECTORY_GET_ERROR,
	DIRECTORIES_GET,
	DIRECTORY_GET,
	DIRECTORY_CLEAR,
	GET_SUB_DIRECTORIES,
	DIRECTORIES_CLEAR,
} from '@/store/directory/types'

const initialState = {
	loading: false,

	directories: [],
	directory: null,
	subDirectories: [],
	pageCount: {
		directories: 0,
		subDirectories: 0,
	},
	errors: [],
}

export const state = { ...initialState }

export default {
	[GET_SUB_DIRECTORIES]: (state, payload) => {
		state.subDirectories = [...payload.data]
		state.pageCount.subDirectories = +payload.pageCount
	},
	[DIRECTORY_GET_STATUS]: (state, status) => {
		state.loading = status
	},
	[DIRECTORY_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[DIRECTORIES_GET]: (state, payload) => {
		state.directories = [...payload.data]
		state.pageCount.directories = +payload.pageCount
	},
	[DIRECTORY_GET]: (state, payload) => {
		state.directory = payload
	},
	[DIRECTORY_CLEAR]: (state) => {
		state.directory = null
	},
	[DIRECTORIES_CLEAR]: (state) => {
		state.directories = []
	},
}
